import React from 'react'

const DocumentModal = ({
  isOpen,
  children,
  footer,          // ← add this
  modalMainClass,
  modalZIndex,
  show = "show",
}) => {

  return (

    <div>
      {isOpen && (
        <div
          id="myModal"
          className={`modal fade ${show} d-block ${modalMainClass}`}
          tabIndex="-1"
          role="dialog"
          style={{ zIndex: modalZIndex }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content border_mosn"
              style={{ display: modalZIndex == -1 ? "none" : "" }}
            >
              {children}
              {footer && (         // ← guard render
                <div className="modal-footer">
                  {footer}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentModal